import apiClient from './apiClient'


const getContracts = (tenant, projectId) => {
  return apiClient.get(`/${tenant}/Contract/${projectId}`)
}

const getContract = (tenant, projectId, contractId) => {
  return apiClient.get(`/${tenant}/Contract/${projectId}/${contractId}`)
}

const createContract = (tenant, projectId, contract) => {
  return apiClient.post(`/${tenant}/Contract/${projectId}`, contract)
}

const putContract = (tenant, projectId, contractId, contract) => {
  return apiClient.put(`/${tenant}/Contract/${projectId}/${contractId}`, contract)
}

const deleteContract = (tenant, projectId, contractId) => {
  return apiClient.delete(`/${tenant}/Contract/${projectId}/${contractId}`)
}

const setContractStatus = (tenant, projectId, contractId, status) => {
  return apiClient.put(`/${tenant}/Contract/${projectId}/${contractId}/status/${status}`)
}

const getContractPdf = (tenant, projectId, contractId) => {
  return apiClient.get(`/${tenant}/Contract/${projectId}/${contractId}/pdf`, { responseType: 'blob' })
}


export default {
  getContracts,
  getContract,
  createContract,
  putContract,
  deleteContract,
  setContractStatus,
  getContractPdf
}
